import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Button, Flex } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { AnimatePresence, motion } from 'motion/react';
import { useCallback, useRef, useState } from 'react';
import { useBaleInboundContext } from '../hook';

export const BaleInboundScanPage = () => {
	const navigate = useNavigate();
	const {
		manualCodeEntryOpen,
		setManualCodeEntryOpen,
		handleScan,
		setWorkflowType,
		setPage,
		setError,
	} = useBaleInboundContext();
	const [loading, setLoading] = useState(false);
	const [code, setCode] = useState('');
	const invalidCode = useRef<string | null>(null);
	const [result, setResult] = useState<'NOT_FOUND' | 'DOCKET_MATCH' | 'BALE_MATCH' | null>(null);

	const handleSearch = useCallback(
		async (scannableCode: string) => {
			setLoading(true);
			const result = await handleScan(scannableCode);
			setLoading(false);
			console.log('handleSearch result', result);
			if (result.result === 'NOT_FOUND') {
				setResult('NOT_FOUND');
				setError('LOAD_NOT_FOUND');
				invalidCode.current = scannableCode;
			} else {
				setPage('RECEIVING');
				setManualCodeEntryOpen(false);
			}
		},
		[handleScan, setError, setPage, setManualCodeEntryOpen]
	);

	return (
		<MobileContainer
			header={
				<MobileHeader title="Bale Inbound" onClose={() => navigate({ to: '/facility/home' })} />
			}
		>
			<Scanner onScan={handleSearch} />
			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={manualCodeEntryOpen}
				instructions="Please enter either the docket ID or a code from any of the bales."
				onClose={() => setManualCodeEntryOpen(false)}
				error={
					result === 'NOT_FOUND'
						? 'No matching loads found. Please double check the entered details or try another code.'
						: undefined
				}
				actions={({ onClose }) => {
					return (
						<div style={{ position: 'relative', height: 200, width: '100%' }}>
							<AnimatePresence initial={false}>
								{result === null && (
									<motion.div
										key="search-actions"
										style={{
											display: 'flex',
											flexDirection: 'row',
											gap: '10px',
											position: 'absolute',
											width: '100%',
											top: 0,
										}}
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										exit={{ opacity: 0 }}
									>
										<Button variant="filled" bg="grey" c="white" fullWidth onClick={onClose}>
											Cancel
										</Button>
										<Button
											variant="filled"
											loading={loading}
											fullWidth
											onClick={() => handleSearch(code)}
										>
											Submit
										</Button>
									</motion.div>
								)}
								{result === 'NOT_FOUND' && (
									<motion.div
										key="not-found"
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										exit={{ opacity: 0 }}
										style={{
											display: 'flex',
											flexDirection: 'column',
											gap: '10px',
											position: 'absolute',
											width: '100%',
											top: 0,
										}}
									>
										<Flex gap="sm">
											<Button variant="filled" bg="grey" c="white" fullWidth onClick={onClose}>
												Cancel
											</Button>
											<Button
												variant="filled"
												fullWidth
												onClick={() => {
													onClose();
													setWorkflowType('MANUAL');
													setTimeout(() => {
														setPage('MANUAL_CREATE:ROOT');
													}, 300);
												}}
											>
												Enter Load Details
											</Button>
										</Flex>
									</motion.div>
								)}
							</AnimatePresence>
						</div>
					);
				}}
			/>
		</MobileContainer>
	);
};
